function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Tack = function Tack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.571 3.506a.75.75 0 0 1 .895.125l3.484 3.484a.75.75 0 0 1 .093.946l-2.703 4.056c-.37.555-.564 1.202-.794 1.97l-.116.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-8.13-8.13a.75.75 0 0 1-.054-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486zm.234 1.586L13.567 6.89c-.57.316-1.173.5-1.743.634-.286.068-.572.126-.845.18l-.02.005c-.27.054-.524.105-.772.163-.894.208-2.074.759-3.263 2.055l7.173 7.173.013-.012c.206-.201.444-.469.684-.788.486-.642.95-1.447 1.201-2.266l.104-.347c.223-.753.486-1.644.993-2.403l2.362-3.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M16.571 3.506a.75.75 0 0 1 .895.125l3.484 3.484a.75.75 0 0 1 .093.946l-2.703 4.056c-.37.555-.564 1.202-.794 1.97l-.116.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-8.13-8.13a.75.75 0 0 1-.054-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486zm.234 1.586L13.567 6.89c-.57.316-1.173.5-1.743.634-.286.068-.572.126-.845.18l-.02.005c-.27.054-.524.105-.772.163-.894.208-2.074.759-3.263 2.055l7.173 7.173.013-.012c.206-.201.444-.469.684-.788.486-.642.95-1.447 1.201-2.266l.104-.347c.223-.753.486-1.644.993-2.403l2.362-3.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l5.807 5.806a.75.75 0 0 1-1.06 1.06L15.243 3.53a.75.75 0 0 1 0-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l5.807 5.806a.75.75 0 0 1-1.06 1.06L15.243 3.53a.75.75 0 0 1 0-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.498 13.502a.75.75 0 0 1 0 1.06L3.53 21.53a.75.75 0 0 1-1.06-1.06l6.967-6.968a.75.75 0 0 1 1.061 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M10.498 13.502a.75.75 0 0 1 0 1.06L3.53 21.53a.75.75 0 0 1-1.06-1.06l6.967-6.968a.75.75 0 0 1 1.061 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
export default Tack;
Tack.displayName = 'Tack';